import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthStore } from '../state/auth/auth.store';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard {
  private authStore = inject(AuthStore);
  private router = inject(Router);

  canActivate(
    pathIfNotAdmin: string
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.getUser(pathIfNotAdmin);
  }

  canActivateChild(
    pathIfNotAdmin: string
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.getUser(pathIfNotAdmin);
  }

  private getUser(pathIfNotAdmin: string) {
    return toObservable(this.authStore.user).pipe(
      filter((user) => user !== null),
      map((user) => {
        if (user?.isAdmin) {
          return true;
        } else {
          this.router.navigateByUrl(pathIfNotAdmin);
          return false;
        }
      })
    );
  }
}
